import React, { lazy, memo } from 'react'
import SuspenseWithCatch from '../../ui/SuspenseWithCatch'
import ReloadNotification from '../../ui/ReloadNotification'
import type { OwnProps } from './GuestGroupCallPage'
import { Bundles, loadBundle } from '../../../util/moduleLoader'

const GuestGroupCallPageAsync = lazy(() =>
  loadBundle(Bundles.Calls).then((bundle) => ({ default: bundle.GuestGroupCallPage })),
)

const GuestGroupCallPage = (props: OwnProps) => {
  return (
    <SuspenseWithCatch fallback={<ReloadNotification />}>
      <GuestGroupCallPageAsync {...props} />
    </SuspenseWithCatch>
  )
}

export default memo(GuestGroupCallPage)
